"use client";

import ErrorPage from "@/ui/AppRouter/ErrorPage";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <ErrorPage
      error={error}
      reset={reset}
      title="Something went wrong"
      description="An unexpected error occurred while loading this page."
    />
  );
}
